import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Monitor, Play, Loader2, Download } from "lucide-react";

const BROWSER_ADVANTAGES = [
  ["Sem instalar nada", "Funciona em qualquer navegador"],
  ["Sem permissoes", "Nenhum popup de Allow/Block"],
  ["Qualquer impressora", "USB, rede, WiFi, Bluetooth"],
  ["Simples", "Selecione a impressora 1x e pronto"],
];

export function BrowserMethodSection({ browserTestPrinting, handleTestBrowser, handleDownloadReceipt }) {
  return (
    <div className="space-y-4">
      <Card className="border-l-4 border-l-violet-500" data-testid="browser-advantages">
        <CardContent className="py-4">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-center">
            {BROWSER_ADVANTAGES.map(([title, desc], i) => (
              <div key={i} className="space-y-1">
                <CheckCircle2 className="w-5 h-5 text-violet-500 mx-auto" />
                <p className="text-xs font-bold text-gray-700">{title}</p>
                <p className="text-[10px] text-gray-500">{desc}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      <Card className="border-l-4 border-l-violet-500" data-testid="browser-setup">
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2 text-base">
            <Monitor className="w-5 h-5" /> Impressao via Navegador
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 pt-0">
          <div className="space-y-2">
            <p className="text-sm text-gray-600">
              Este metodo usa o <strong>dialogo de impressao do navegador</strong> para enviar o recibo
              para qualquer impressora configurada no computador.
            </p>
            <div className="bg-violet-50 border border-violet-200 p-3 rounded-lg text-xs text-violet-700 space-y-1">
              <p className="font-bold">Como funciona:</p>
              <ul className="list-disc list-inside space-y-0.5">
                <li>Ao imprimir, aparece o dialogo de impressao do navegador</li>
                <li>Selecione a impressora termica e clique em "Imprimir"</li>
                <li>O recibo sai formatado para papel de 80mm</li>
                <li>Dica: No Chrome, marque "Lembrar esta impressora" para automatizar</li>
              </ul>
            </div>
          </div>

          <Button
            onClick={handleTestBrowser}
            disabled={browserTestPrinting}
            className="bg-violet-600 hover:bg-violet-700 gap-2 h-12 font-bold text-base w-full"
            data-testid="test-browser-print-btn"
          >
            {browserTestPrinting ? <Loader2 className="w-5 h-5 animate-spin" /> : <Play className="w-5 h-5" />}
            IMPRIMIR PAGINA DE TESTE
          </Button>
          <Button
            onClick={handleDownloadReceipt}
            variant="outline"
            className="gap-2 h-10 w-full text-violet-700 border-violet-300 hover:bg-violet-50"
            data-testid="download-receipt-btn"
          >
            <Download className="w-4 h-4" />
            BAIXAR RECIBO (se impressao nao abre)
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
